// noinspection JSUnresolvedReference

import React from 'react';
import {Button, Card} from "@deere/ux.uxframe-react";
import {useDispatch, useSelector} from "react-redux";
import {customerList, setSelectedCustomer} from "./customersSlice";
import {useHistory} from "react-router-dom";
import {languageResponseData} from "../Translation/translationSerachSlice";

export const CustList = ({userType}) => {
    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse[key] || defaultText;
    };

    const history = useHistory();
    const dispatch = useDispatch();
    const customers = useSelector(customerList);

    const fetchMachinesForCustomer = (customer) => {
        dispatch(setSelectedCustomer(customer));
        history.push({pathname: `/machine-search/customer/${customer.entityId}/machines`, state: {customer}})
    }

    return (
        customers && customers.length > 0 && userType === "I" ? (
            <Card>
                <Card.Header><strong>{"Customer List"}</strong></Card.Header>
                <Card.Body>
                    <IndividualCustomerList
                        customers={customers}
                        fetchMachines={fetchMachinesForCustomer}
                        translate={translate}
                    />

                </Card.Body>
            </Card>
        ) : customers && customers.length > 0 && userType === "B" && (
            <Card>
                <Card.Header><strong>{translate('customer_list', 'Customer List')}</strong></Card.Header>
                <Card.Body>
                    <BusinessCustomerList
                        customers={customers}
                        fetchMachines={fetchMachinesForCustomer}
                        translate={translate}
                    />
                </Card.Body>
            </Card>
        )
    )
}
export const IndividualCustomerList = ({customers, fetchMachines,translate}) => {
    return (
        <div>
            {/*<pre>{JSON.stringify(customers)}</pre>*/}
            <table className="table table-sm table-uxf-modern">
                <thead>
                <tr>
                    <th scope="col">{translate('prefix', 'Prefix')}</th>
                    <th scope="col">{translate('lastName', 'Last Name')}</th>
                    <th scope="col">{translate('middle_name', 'Middle Name')}</th>
                    <th scope="col">{translate('firstName', 'First Name')}</th>
                    <th scope="col">{translate('streetAddress', 'Address')}</th>
                    <th scope="col">{translate('addressLine2', 'Address2')}</th>
                    <th scope="col">{translate('city', 'City')}</th>
                    <th scope="col">{translate('stateProvince', 'State/Province')}</th>
                    <th scope="col">{translate('country', 'Country')}</th>
                    <th scope="col">{translate('ckc_id', 'CKC ID #')}</th>
                    <td/>
                </tr>
                </thead>
                <tbody>
                {customers && Array.isArray(customers) && customers.map(customer => {
                    return (
                        <tr key={customer.entityId}>
                            <td>{customer.namePrefix}</td>
                            <td><Button
                                variant="link"
                                onClick={() => fetchMachines(customer)}
                            >{customer.lastName}
                            </Button>
                            </td>
                            <td>{customer.middleName}</td>
                            <td><Button
                                variant="link"
                                onClick={() => fetchMachines(customer)}
                            >{customer?.firstName}</Button></td>
                            <td>{customer.addresses[0]?.street ? customer.addresses[0]?.street : ""}</td>
                            <td>{customer.addresses[0]?.street2 ? customer.addresses[0]?.street2 : ""}</td>
                            <td>{customer.addresses[0]?.city ? customer.addresses[0]?.city : ""}</td>
                            <td>{customer.addresses[0]?.state ? customer.addresses[0]?.state : ""}</td>
                            <td>{customer.addresses[0]?.country ? customer.addresses[0]?.country : ""}</td>
                            <td>{customer.entityId}</td>
                        </tr>)
                })}
                </tbody>
            </table>
        </div>
    );
};

export const BusinessCustomerList = ({customers, fetchMachines,translate}) => {
    return (
        <div>
            <table className="table table-sm table-uxf-modern">
                <thead>
                <tr>
                    <th scope="col">{translate('company_name', 'Company Name')}1</th>
                    <th scope="col">{translate('company_name', 'Company Name')}2</th>
                    <th scope="col">{translate('streetAddress', 'Address')}</th>
                    <th scope="col">{translate('addressLine2', 'Address2')}</th>
                    <th scope="col">{translate('city', 'City')}</th>
                    <th scope="col">{translate('stateProvince', 'State/Province')}</th>
                    <th scope="col">{translate('country', 'Country')}</th>
                    <th scope="col">{translate('ckc_id', 'CKC ID #')}</th>
                    <td/>
                </tr>
                </thead>
                <tbody>
                {customers?.map(customer => {
                    return (<tr key={customer.entityId}>
                        <td>
                            <Button
                                variant="link"
                                onClick={() => fetchMachines(customer)}
                            >{customer.businessName1}
                            </Button>
                        </td>
                        <td><Button variant="link" onClick={() => fetchMachines(customer)}>{customer.businessName2}</Button></td>
                        <td>{customer.addresses[0]?.street ? customer.addresses[0]?.street : ""}</td>
                        <td>{customer.addresses[0]?.street2 ? customer.addresses[0]?.street2 : ""}</td>
                        <td>{customer.addresses[0]?.city ? customer.addresses[0]?.city : ""}</td>
                        <td>{customer.addresses[0]?.state ? customer.addresses[0]?.state : ""}</td>
                        <td>{customer.addresses[0]?.country ? customer.addresses[0]?.country : ""}</td>
                        <td>{customer.entityId}</td>
                    </tr>)
                })}
                </tbody>
            </table>
        </div>
    );
};
